"use client";

import { c as _c } from "react/compiler-runtime";
import { Icon, Typography } from "@/shared/ui/atoms";
import { CustomButton } from "..";
import { HeartIcon } from "@/shared/ui/atoms";
import { useState } from "react";
import { HospitalInfoType } from "@/entities/hospital/types/type";
import { useMutationDeleteHospitalFavorite, useMutationPostHospitalFavorite } from "@/entities/user/hooks/useUser";
import { formatFivePointRating } from "@/entities/hospital/lib/rating";
interface HospitalInfoProps {
  hospitalInfo: HospitalInfoType;
  isShowFavoriteButton?: boolean;
}
const HospitalCardInfo = t0 => {
  const $ = _c(37);
  const {
    hospitalInfo,
    isShowFavoriteButton: t1
  } = t0;
  const isShowFavoriteButton = t1 === undefined ? false : t1;
  const [isFavorite, setIsFavorite] = useState(true);
  const {
    name,
    fullAddress,
    score,
    reviewCount,
    categoryName,
    hospitalOriginId: t2
  } = hospitalInfo;
  const hospitalOriginId = t2 === undefined ? 0 : t2;
  const {
    mutate: postHospitalFavorite
  } = useMutationPostHospitalFavorite();
  const {
    mutate: deleteHospitalFavorite
  } = useMutationDeleteHospitalFavorite();
  const hasReviewCount = Boolean(reviewCount && reviewCount > 0);
  let t3;
  if ($[0] !== hasReviewCount || $[1] !== score) {
    t3 = hasReviewCount && score != null ? formatFivePointRating(score) : score === 0 ? "0" : score?.toFixed(1);
    $[0] = hasReviewCount;
    $[1] = score;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const formattedScore = t3;
  let t4;
  if ($[3] !== deleteHospitalFavorite || $[4] !== hospitalOriginId || $[5] !== isFavorite || $[6] !== postHospitalFavorite) {
    t4 = () => {
      setIsFavorite(!isFavorite);
      if (isFavorite) {
        deleteHospitalFavorite(hospitalOriginId);
      } else {
        postHospitalFavorite(hospitalOriginId);
      }
    };
    $[3] = deleteHospitalFavorite;
    $[4] = hospitalOriginId;
    $[5] = isFavorite;
    $[6] = postHospitalFavorite;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const changeFavoriteButton = t4;
  const t5 = `font-bold tracking-[-0.2px] ${hasReviewCount ? "max-w-[75%]" : "max-w-[100%]"}`;
  let t6;
  if ($[8] !== name || $[9] !== t5) {
    t6 = <Typography size={20} lineHeight={22} className={t5}>{name}</Typography>;
    $[8] = name;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Icon src="/icons/star.svg" alt="star" width={16} height={16} />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== formattedScore) {
    t8 = <Typography size={14} lineHeight={22} className="flex items-center gap-[2px] font-bold text-[#333438]">{t7}{formattedScore}</Typography>;
    $[12] = formattedScore;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== hasReviewCount || $[15] !== reviewCount) {
    t9 = hasReviewCount && <Typography size={14} lineHeight={20} className="text-[#AEB0B6]">({reviewCount})</Typography>;
    $[14] = hasReviewCount;
    $[15] = reviewCount;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t6 || $[18] !== t8 || $[19] !== t9) {
    t10 = <div className="flex items-center gap-1">{t6}{t8}{t9}</div>;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  const t11 = `w-fit text-[#46474C] ${categoryName ? "max-w-[60%]" : "max-w-[100%] break-keep"}`;
  let t12;
  if ($[21] !== fullAddress || $[22] !== t11) {
    t12 = <Typography size={14} lineHeight={22} className={t11}>{fullAddress}</Typography>;
    $[21] = fullAddress;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== categoryName) {
    t13 = categoryName && <><span className="text-[#E1E2E4]">|</span><Typography size={14} lineHeight={22} className="flex-1 text-[#46474C]">{categoryName}</Typography></>;
    $[24] = categoryName;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t12 || $[27] !== t13) {
    t14 = <div className="flex items-start gap-[6px]">{t12}{t13}</div>;
    $[26] = t12;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== changeFavoriteButton || $[30] !== isFavorite || $[31] !== isShowFavoriteButton) {
    t15 = isShowFavoriteButton && <div onClick={_temp}><CustomButton className="absolute top-0 right-0" onClick={changeFavoriteButton}><HeartIcon isSelected={isFavorite} /></CustomButton></div>;
    $[29] = changeFavoriteButton;
    $[30] = isFavorite;
    $[31] = isShowFavoriteButton;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t10 || $[34] !== t14 || $[35] !== t15) {
    t16 = <div className="relative flex flex-col gap-1">{t10}{t14}{t15}</div>;
    $[33] = t10;
    $[34] = t14;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  return t16;
};
export default HospitalCardInfo;
function _temp(e) {
  e.preventDefault();
  e.stopPropagation();
}